export const promoter = {
	title: "Promotores",
	promoter: {
		menu: {
			deactivate: "Desactivar",
			activate: "Activar",
			edit: "Editar",
		},
		table: {
			name: "Nombre",
			email: "E-mail",
			phone: "Teléfono",
			accessLevel: "Nivel de acceso",
			active: "Activo",
			pending: "Pendiente",
			inactive: "Inactivo",
		},
		content: {
			titleAddPromoter: "Agregar promotor",
			titleEditPromoter: "Editar promotor",
		},
		header: {
			title: "Promotores",
			text: "Área del promotor:",
			promoter: "promotor",
			promoters: "promotores",
			buttonAddPromoter: "Agregar promotor",
			buttonCopyPromoter: "Copiar",
			buttonCopyPromoterSuccess: "Link copiado",
			buttonSearch: "Buscar",
			active: "Activo",
			inactive: "Inactivo",
			pending: "Pendiente",
		},
		addPromoter: {
			subtitle: "Enviar invitación para:",
			textAddPromoter:
				"Escriba el e-mail del promotor al que desea permitir acceso a las listas de invitados.",
			messageAddPromoter:
				"Para agregar más de un promotor, solo separe los e-mails por coma (,)",
			buttonInvite: "Enviar invitación",
			successTittle: "¡Invitación enviada con éxito!",
			successText: "La invitación fue enviada a los e-mails registrados",
			successButton: "Agregar promotor",
		},
		editPromoter: {
			textStatusPromoter: "Estado",
			textLevelPromoter: "Nivel de acceso",
			name: "Nombre",
			email: "Email",
			phone: "Teléfono",
			messageLevelPromoter:
				"Puede visualizar los eventos, agregar y editar invitados en las listas",
			messageToolTipPromoter: "El estado define si el promotor tiene acceso a sus listas",
			pendingStatus: "Pendiente",
			buttonInvite: "Reenviar invitación",
			buttonInviteSave: "Guardar edición",
			successTittle: "¡Invitación enviada con éxito!",
			successText: "La invitación fue enviada a los e-mails registrados",
			successButton: "Agregar promotor",
			active: "Activo",
			inactive: "Inactivo",
		},
		store: {
			messageActive: "Usuario activado con éxito",
			messageDeactive: "Usuario desactivado con éxito",
			messageSuccess: "Invitación reenviada con éxito",
			messageEdit: "Datos del promotor modificados con éxito",
		},
	},
};
